import React, { useEffect, useState } from "react";
import CategoriesList, { Category } from "./CategoriesListL";
import useOffer from "@/hooks/useTender";

export const MyCompanyPage: React.FC = () => {
  const [categoris, setCategoris] = useState<Category[]>([]);
  const { getParentCategories } = useOffer();

  useEffect(() => {
    const fetchCategoris = async () => {
      try {
        const Categories = await getParentCategories();
        if (Categories) {
          setCategoris(Categories.data);
        }
      } catch (error) {
        console.error("Error fetching Offers:", error);
      }
    };
    fetchCategoris();
  }, []);

  return (
    <div>
      <CategoriesList data={categoris} />
    </div>
  );
};

export default MyCompanyPage;
